export const mainMockup =
  'https://cdn.magicpatterns.com/uploads/5hKdRo7XnguXjvAAMZTxdy/Diseno_sin_titulo_(69).png'

export const carouselImages = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/8jtXGzVw2RvtLohJX4kkms/Captura_de_pantalla_2026-10-04_230543.png',
    alt: 'Inside Pastry Instructor Ready, page 1',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/eQEpYj4ZX9pxLBQ1fDkrVR/Captura_de_pantalla_2026-10-04_230607.png',
    alt: 'Inside Pastry Instructor Ready, page 2',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/c98JWiyjHBT3fx4L7ukQvR/Captura_de_pantalla_2026-10-04_230634.png',
    alt: 'Inside Pastry Instructor Ready, page 3',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/r4H4aHLDL4qiMGahrviYau/Captura_de_pantalla_2026-10-04_230701.png',
    alt: 'Inside Pastry Instructor Ready, page 4',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/5EPwcFkj46CpyEXeUUXo5e/Captura_de_pantalla_2026-10-04_230837.png',
    alt: 'Inside Pastry Instructor Ready, page 5',
  },
]
